module.exports = __webpack_public_path__ + "static/media/pacRoyale-gameplay1.f260cddb.png";